export const RecaptchaMixin = {
    data() {
        return {
            recaptcha_site_key: process.env.RECAPTCHA_SITE_KEY,
        }
    },
    methods: {
        async recaptcha() {
            try {
                await this.$recaptchaLoaded()

                return await this.$recaptcha('login')
            } catch (e) {
                return null
            }
        }
    },
    mounted() {
        // this.recaptcha().then((token) => this.user.recaptcha = token)

        /*this.intervalId = setInterval(() => {
            this.recaptcha().then((token) => this.user.recaptcha = token)
        }, 90 * 1000)*/
    },
    beforeDestroy() {
        // clearInterval(this.intervalId);
    },
}
